import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../config/authConfig";
import { Button, Container, Box } from "@mui/material";
import LogoCaldenFlow from "../../utils/images/logo_audit.png";

const Login = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      await instance.loginRedirect({
        ...loginRequest,
        prompt: "select_account",
      });
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1559a5 0%, #0d3a70 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 20% 80%, rgba(255,255,255,0.05) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.05) 0%, transparent 50%)",
          pointerEvents: "none",
        },
      }}
    >
      <Container maxWidth="xs">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={LogoCaldenFlow}
            alt="CaldenFlow Logo"
            sx={{
              width: "280px",
              height: "auto",
              mb: 4,
              filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.1))",
            }}
          />

          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleLogin}
            sx={{
              py: 1.5,
              borderRadius: "12px",
              backgroundColor: "#113155",
              fontSize: "1rem",
              fontWeight: 600,
              textTransform: "none",
              boxShadow: "0 4px 14px rgba(21, 89, 165, 0.3)",
              "&:hover": {
                backgroundColor: "#0d3a70",
                boxShadow: "0 6px 20px rgba(21, 89, 165, 0.4)",
              },
              "&:disabled": {
                backgroundColor: "#94a3b8",
              },
            }}
          >
            INGRESAR
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Login;
